import { apiClient } from '../client';



export const signIn = async (): Promise<any> => {  
  try{
    const response = await apiClient.get('/account/user/sign-in', {
      params: { component_id: import.meta.env.VITE_PUBLIC_COMPONENT_ID },
    });
    // throw new Error("aaaa");
    return {
      data: response.data,
    };
  } catch (error: any) {
    if (error?.message == "aaaa"){
      return {
        errorCode: "SS-019",
        errorMessage: "No profile found",
      };
    }
    // in case of access denied or wrong credentials
    return {
      errorCode: error.response?.data?.exceptionResponse?.errorCode,
      errorMessage: error.response?.data?.exceptionResponse?.errorMessage || error.response?.data?.message,
    };
  }
};


export const authenticateUser = async (
  keycloakTokens: {
    access_token: string;
    id_token: string;
    refresh_token: string;
    expires_at: number;
  }
): Promise<any> => {
  try {
 // Set token in localStorage for API calls
 localStorage.setItem("token", keycloakTokens.access_token);
    // Call sign-in API
    const userInfoResponse = await signIn();
    if (userInfoResponse.errorCode =="SS-019" || userInfoResponse.message?.toLowerCase()?.includes("no profile found")) {
      return {
        hasAccess: false,
        errorMessageKey: "Access denied",
      };
    }
      return {
        hasAccess: true,
        userInfo: userInfoResponse.data,
      };
    } catch (error: any) {
      // Access denied
      if (error.errorCode =="SS-019" || error.message?.toLowerCase()?.includes("no profile found")) {
        return {
          hasAccess: false,
          errorMessageKey: "Access denied",
        };
      }
      // Authentication failed
      return {
        hasAccess: false,
          errorMessageKey: 'shared.auth.authenticationFailed',
        };
    }
  }

  export const handleAuthenticationError = (
    store: any,
    logout: any
  ): void => {
    store.dispatch(logout());
    localStorage.removeItem("token");
    sessionStorage.clear();
    window.location.href = "/login";
  };

  // update the last login time
  export const updateLastLoginTime = async (): Promise<any> => {
    try {
      await apiClient.post('/account/v3/user/login');
    } catch (error: any) {
      return {
        errorCode: error.response?.data?.exceptionResponse?.errorCode,
        errorMessage: error.response?.data?.exceptionResponse?.errorMessage || error.response?.data?.message,
      };
    }
  };